// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ncWa","amount":"Amount_amount__1pCh6","tip":"Amount_tip__1U6yl","tipHeader":"Amount_tipHeader__OS6Mp","tipsWrap":"Amount_tipsWrap__2rZb5"};